import { AuthLayout } from "../../../layouts/auth/authLayout";
import { FormLogin } from "../../../components/auth/login/formLogin";
import { useEffect, useLayoutEffect, useState } from "react";
import { useAuthStore } from "hooks/useAuthStore";
import { onAddImagenHora } from "store";
import { useDispatch } from "react-redux";
import { FormNormas } from "components/normatividad/formNormas";

export const LoginScreen = () => {
  const {isNorma, startGetHoraImagen, changeSeccionSelect } = useAuthStore();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Inicia Sesión";
    changeSeccionSelect(1)
  }, []);

  useLayoutEffect(() => {
    dispatch(onAddImagenHora("dia"));
    // startGetHoraImagen();
  }, []);

  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <div
        className={`transition-transform duration-500 ease-in-out ${
          isNorma ? "-translate-x-full " : "translate-x-0"
        }`}
        style={{
          opacity: isNorma ? 0.3 : 1,
        }}
      >
        <AuthLayout title="Iniciar Sesión">
          <FormLogin />
        </AuthLayout>
      </div>

      {isNorma ? (
        <div
          className={`absolute top-0 left-0 w-full transition-transform duration-500 ease-in-out ${
            isNorma ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <FormNormas isNormas={isNorma} />
        </div>
      ) : null}
    </div>
  );
};
